<template>
  <v-row>
    <v-col cols="12">
      <v-card flat class="mt-10 rounded-xl secondary--border overflow-y-auto">
        <v-data-table
          :headers="headers"
          :items="referrals"
          hide-default-footer
          :loading="loading"
        >
          <template v-slot:header.name="{ header }">
            <div
              class="py-6 px-5 text-body-1 font-weight-bold primary--text d-flex align-center"
            >
              <span class="font-weight-bold">{{ header.text }}</span>
            </div>
          </template>
          <template v-slot:header.createdat="{ header }">
            <div class="py-6 text-body-1 font-weight-bold primary--text">
              {{ header.text }}
            </div>
          </template>
          <template v-slot:header.hasinvested="{ header }">
            <div class="py-6 text-body-1 font-weight-bold primary--text">
              {{ header.text }}
            </div>
          </template>
          <template v-slot:header.hashome="{ header }">
            <div class="py-6 text-body-1 font-weight-bold primary--text">
              {{ header.text }}
            </div>
          </template>

          <template v-slot:item.name="{ item }">
            <div
              class="py-5 text-body-1 font-weight-medium d-flex align-center justify-space-between"
              :class="{'flex-column ': $vuetify.breakpoint.mdAndDown}"
            >
              <div class="pl-5">{{ item.firstname }} {{ item.lastname }}</div>

              <div class="d-flex" :class="{'ml-auto mt-2': $vuetify.breakpoint.mdAndDown}">
                <v-card flat color="secondary" class="rounded-circle">
                  <v-btn icon color="white">
                    <a
                      :href="`tel:${item.phonenumber}`"
                      class="text-decoration-none"
                    >
                      <v-icon size="20" color="white">mdi-phone</v-icon>
                    </a>
                  </v-btn>
                </v-card>
                <v-card flat color="secondary" class="rounded-circle ml-4">
                  <v-btn icon color="white">
                    <a
                      :href="`mailto:${item.email}`"
                      class="text-decoration-none"
                    >
                      <v-icon size="20" color="white">mdi-email</v-icon>
                    </a>
                  </v-btn>
                </v-card>
              </div>
            </div>
          </template>
          <template v-slot:item.createdat="{ item }">
            <div class="text-body-1">
              {{ formatDate(item.createdat) }}
            </div>
          </template>
          <template v-slot:item.hasinvested="{ item }">
            <div
              class="text-body-1"
              :class="item.hasinvested ? 'success--text' : 'error--text'"
            >
              {{ item.hasinvested ? "Yes" : "No" }}
            </div>
          </template>
          <template v-slot:item.hashome="{ item }">
            <div
              class="text-body-1"
              :class="item.homevest ? 'success--text' : 'error--text'"
            >
              {{ item.homevest ? "Yes" : "No" }}
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <v-col>
      <v-col cols="12">
        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
import { UserService } from "@/services/index.js";
import { formatDate } from "@/utils/helpers";

export default {
  data() {
    return {
      formatDate,
      loading: false,
      total: 0,
      perPage: 0,
      lastPage: 0,
      page: 1,
      pageCount: 1,
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Date Joined", value: "createdat", sortable: false },
        { text: "Has Invested", value: "hasinvested", sortable: false },
        // { text: "Landbank", value: "type", sortable: false },
        { text: "Homes", value: "hashome", sortable: false },
      ],
      referrals: [],
    };
  },
  methods: {
    async getReferrals() {
      this.loading = true;
      try {
        const {
          data: { data: referrals, lastPage, perPage, total, page },
        } = await UserService.getReferrals(this.page);
        this.referrals = referrals;
        // console.log(lastPage);
        this.perPage = perPage;
        this.lastPage = lastPage;
        this.pageCount = Number(lastPage);
        this.loading = false;
      } catch (err) {
        this.loading = false;

        // throw err;
      }
    },
  },
  mounted() {
    this.getReferrals();
  },
  watch: {
    page() {
      this.getReferrals();
    },
  },
};
</script>

<style lang="scss" scoped>
.theme--light.v-data-table tbody tr:nth-of-type(odd) {
  background-color: #fff9f2;
  border: 5px solid blue !important;
  border-top: none !important;
  border-bottom: none !important;
}
.theme--dark.v-data-table tbody tr:nth-of-type(odd) {
  background-color: #fff9f2;
  border: 5px solid blue !important;
  border-bottom: none !important;
  border-top: none !important;
}
</style>
